<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Σύνοψη Αδειών Ανά Τύπο</h4>
          <p class="card-title-desc"></p>
          <div class="row">
            <div class="md-4 d-flex">
              <b-button variant="success" class="me-2" v-b-modal="`HolidayApplicationForm`">Αίτηση Άδειας</b-button>
              <b-button variant="primary" v-b-modal="`MyHolidaysmodalRequest`">Οι Αιτήσεις μου</b-button>
            </div>
          </div>
          <div class="row mt-5">

            <div class="col-lg-6" v-if="hrmsStats.length > 0">
              <hrmsHolidayTypesTable :statsHrms="hrmsStats" @showChartByLeaveType="showChartByLeaveType">
              </hrmsHolidayTypesTable>
            </div>
            <div v-for="(data, index) in chartData" :key="index" class="col-lg-6 col-md-6 holiday-chart">
              <h4>{{ data.type }}</h4>
              <apexchart class="apex-charts" height="320" type="pie" dir="ltr" :series="data.series"
                :options="data.chartOptions"></apexchart>

            </div>

          </div>

        </div>

        <div v-if="holidayStatsNoHrms.length > 0">
          <chartDataNoHrms :holidayStats="holidayStatsNoHrms"></chartDataNoHrms>
        </div>

      </div>

      <b-modal id="MyHolidaysmodalRequest" centered hide-footer size="xl">
        <requestedHolidays />
      </b-modal>

      <b-modal id="HolidayApplicationForm" centered hide-footer>
        <applicationHolidayModalVue @requestedDone="requestedDone" :hrmsIsActive="hrmsActive"
          :hrmsHolidayTypes="hrmsHolidayTypes" />
      </b-modal>

    </div>
  </Layout>
</template>

<script>
import Layout from "../../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { simplePieChart } from "../../../charts/data-chartist";
import requestedHolidays from "./requestedHolidays.vue";
import applicationHolidayModalVue from "./applicationHolidayModalVue.vue";
import session from "../../../../../api/session";
import chartDataNoHrms from "./chartDataNoHrms.vue";
import moment from "moment";
import Swal from "sweetalert2";
import hrmsHolidayTypesTable from "./hrmsHolidayTypesTable.vue";
export default {
  page: {
    title: "Αίτηση Άδειας",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    requestedHolidays,
    applicationHolidayModalVue,
    chartDataNoHrms,
    hrmsHolidayTypesTable,
  },
  data() {
    return {
      title: "Αδειες",
      items: [
        {
          text: "Aρχική",
          to: { name: "homepage" },
        },
      ],
      holidayTypes: [
        {
          type: "Κανονική άδεια",
          total: 20,
          taken: 12,
        },
        {
          type: "Αναρρωτική άδεια",
          total: 10,
          taken: 4,
        },
        {
          type: "Άνευ αποδοχών",
          total: 5,
          taken: 1,
        },
      ],
      chartData: [],
      simplePieChart: simplePieChart,
      hrmsActive: false,
      holidayStatsNoHrms: [],
      hrmsStats: [],
      hrmsHolidayTypes: [],
      holidayLeaveTypeId: 1,
    };
  },
  methods: {
    showChartByLeaveType(leaveTypeId) {
      this.holidayLeaveTypeId = leaveTypeId;
      this.prepareChartData();
    },
    prepareChartData() {
      this.chartData = this.holidayTypes
        .filter((holiday) => holiday.lty_id === this.holidayLeaveTypeId)
        .map((holiday) => {
          const remaining = holiday.total - holiday.taken;

          return {
            type: holiday.type,
            series: [holiday.taken, remaining],
            chartOptions: {
              chart: {
                type: "pie",
                height: 320,
              },
              labels: [
                `Ληφθείσες (${holiday.taken})`,
                `Υπολοιπόμενες (${remaining})`,
              ],
              colors: ["#f46a6a", "#34c38f"],
              legend: {
                show: true,
                position: "bottom",
                horizontalAlign: "center",
                fontSize: "14px",
              },
              tooltip: {
                enabled: true,
                y: {
                  formatter: function (val) {
                    return `${val} μέρες`; // Show days in tooltip
                  },
                },
              },
              responsive: [
                {
                  breakpoint: 600,
                  options: {
                    chart: {
                      height: 240,
                    },
                    legend: {
                      position: "bottom",
                      fontSize: "12px",
                    },
                  },
                },
              ],
            },
          };
        });
    },

    // prepareChartData() {
    //   this.chartData = this.holidayTypes
    //     .filter((holiday) => holiday.lty_id === this.holidayLeaveTypeId)
    //     .map((holiday) => {
    //       const remaining = holiday.total - holiday.taken;
    //       return {
    //         type: holiday.type,
    //         chartData: {
    //           labels: [
    //             `Σύνολο (${holiday.total})`,
    //             `Ληφθείσες (${holiday.taken})`,
    //             `Υπολοιπόμενες (${remaining})`,
    //           ],
    //           series: [holiday.total, holiday.taken, remaining],
    //         },
    //         chartOptions: {
    //           donut: false,
    //           donutWidth: 50,
    //           showLabel: true,
    //           labelOffset: 39,
    //           labelDirection: "explode",
    //           height: 200,
    //         },
    //       };
    //     });
    // },

    requestedDone(data) {
      if (this.hrmsActive) {
        const totalDays = this.calculateTotalHolidayDays(
          data.start_date,
          data.end_date
        );
        const holidayType = this.holidayTypes.find(
          (e) => e.type === data.oracle_leave_type.leave_type
        );
        const remainingholidays = holidayType.total - holidayType.taken;

        if (remainingholidays < totalDays) {
          Swal.fire(
            "Προσοχή!",
            "Έχετε βάλει περισσότερες μέρες από ότι δικαιούστε.",
            "error"
          );
          return;
        }
        this.createHolidayRequest(data);
      } else {
        this.createHolidayRequest(data);
      }
      this.$bvModal.hide(`HolidayApplicationForm`);
    },
    createHolidayRequest(data) {
      session
        .post("api/holiday-request/create/", data)
        .then(() => {
          Swal.fire("Επιτυχία!", "Η αίτηση στάλθηκε.", "success");
        })
        .catch((e) => {
          console.log(e);
          Swal.fire({
            title: "Ουπς! Κάτι πήγε στραβά",
            text: "Παρακαλώ επικοινωνήστε με τους διαχειριστές",
            icon: "error",
          });
        });
    },
    getStatsFromHrms() {
      session
        .get("api/hrms-stats/")
        .then((resp) => {
          this.hrmsStats = resp.data;

          this.hrmsHolidayTypes = resp.data.map((e) => {
            return {
              leave_type: e.leave_type,
              lty_id: e.lty_id,
            };
          });
          this.holidayTypes = resp.data.map((e) => {
            return {
              type: e.leave_type,
              total: e.entitled_days,
              taken: e.taken_days,
              lty_id: e.lty_id,
            };
          });
          //   console.log(this.holidayTypes);
          this.prepareChartData();
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getHrmsActive() {
      session
        .get("api/hrms/hrms-active/")
        .then((resp) => {
          this.hrmsActive = resp.data.is_active;
          if (resp.data.is_active) {
            this.getStatsFromHrms();
          } else {
            this.fetchholidayStatsNoHrms();
          }
          //   if (!resp.data.is_active) {
          //     this.fetchholidayStatsNoHrms();
          //   }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    fetchholidayStatsNoHrms() {
      session
        .get("api/holiday-stats/")
        .then((resp) => {
          this.holidayStatsNoHrms = resp.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    calculateTotalHolidayDays(startDate, endDate) {
      const startdate = moment(startDate);
      const enddate = moment(endDate);
      const result = moment.duration(enddate.diff(startdate)).asDays() + 1;
      return result;
    },
  },

  created() {
    this.getHrmsActive();
  },
};
</script>


<style>
.holiday-chart {
  text-align: center;
}

/* .ct-chart {
  max-height: 800px;
  height: 100%;
} */

.ct-label {
  fill: #6f6f6f !important;
  font-size: 11px;
  font-weight: bold;
}
</style>